import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { ViewerService } from '../../../services/Viewer/viewer.service';
import { AuthenService } from '../../../services/Authen/authen.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import Swal from 'sweetalert2';
import { isPlatformBrowser } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import he from '@angular/common/locales/he';
declare var google: any;
declare var jQuery: any;

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";

import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { callable, session_year } from "src/app/components/callable";

@Component({
  selector: 'app-coop-insert',
  templateUrl: './coop-insert.component.html',
  styleUrls: ['./coop-insert.component.scss']
})
export class CoopInsertComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,

    private CoopServiceService: CoopServiceService,
    private AuthenService: AuthenService,
    private SpinnerService: NgxSpinnerService,
    private router: Router,
    private ViewerService: ViewerService
  ) { }


  PhakId: any = "null";
  searchName_: any
  CoopNameTh: any
  CoopStatusProvinceYearBySearch: any
  CoopProfileAll: any
  coopId: any
  Info: any
  List: any
  OrgOrgId: any = "null";
  KhetId: any = "null";
  KhetId_: any
  PhakByKhet: any
  ProvinceByKhet: any
  PhakList: any
  groupkhet_bkk1: any
  groupkhet_bkk2: any
  checkkhet: any
  groupkhet_1: any
  Month_now_: any

  year_now: any;
  year_now_: any;
  Date_now: any;
  Date_after_day: any;
  Month_now: any;
  datayear: any;
  datayear_Lst: any;
  sumResult = 0
  CoopOracleCount = 0
  CoopOracleCountactive: any
  CoopOracleCountnonActive: any
  MemberSum = 0
  MemberDataM = 0
  MemberDataFm = 0
  CoopOfficerYearMember = 0
  CoopOfficerYearMemberM = 0
  CoopOfficerYearMemberFm = 0
  CommitteeSum = 0
  CommitteeSumM = 0
  CommitteeSumFm = 0
  selectPhak = false
  StandardTypeSum_pass: any = 0
  StandardTypeSum_notPass: any = 0

  StandardType_pass_level1: any
  StandardType_notPass_level1: any

  StandardType_pass_level2: any
  StandardType_notPass_level2: any

  StandardType_pass_level3: any
  StandardType_notPass_level3: any

  StandardType_pass_level4: any
  StandardType_notPass_level4: any

  StandardType_pass_level5: any
  StandardType_notPass_level5: any

  StandardType_pass_level6: any
  StandardType_notPass_level6: any

  StandardType_pass_level7: any
  StandardType_notPass_level7: any

  CoopOracleTypes: any;
  Active_coopType1: any = 0;
  InActive_coopType1: any = 0;
  typeName: any;
  valSum1: any = 0
  valSum2: any = 0
  valSum3: any = 0
  valSum4: any = 0
  valSum5: any = 0
  selectProviceSearch: any;
  listCoop: any;
  sumResult_: any;
  CoopStatusProvinceYearOne: any;
  pageOfItems: Array<any>;
  pageOfItemslistCoop: Array<any>;

  TypeAgri: any;
  TypeCoop: any;

  TypeLevelSum1: any = 0;
  TypeLevelSum2: any = 0;
  TypeLevelSum3: any = 0;
  TypeLevelSum4: any = 0;

  TypeLevel1_type1: any = 0;
  TypeLevel1_type2: any = 0;
  TypeLevel1_type3: any = 0;
  TypeLevel1_type4: any = 0;
  TypeLevel1_type5: any = 0;
  TypeLevel1_type6: any = 0;
  TypeLevel1_type7: any = 0;

  TypeLevel2_type1: any = 0;
  TypeLevel2_type2: any = 0;
  TypeLevel2_type3: any = 0;
  TypeLevel2_type4: any = 0;
  TypeLevel2_type5: any = 0;
  TypeLevel2_type6: any = 0;
  TypeLevel2_type7: any = 0;

  TypeLevel3_type1: any = 0;
  TypeLevel3_type2: any = 0;
  TypeLevel3_type3: any = 0;
  TypeLevel3_type4: any = 0;
  TypeLevel3_type5: any = 0;
  TypeLevel3_type6: any = 0;
  TypeLevel3_type7: any = 0;

  TypeLevel4_type1: any = 0;
  TypeLevel4_type2: any = 0;
  TypeLevel4_type3: any = 0;
  TypeLevel4_type4: any = 0;
  TypeLevel4_type5: any = 0;
  TypeLevel4_type6: any = 0;
  TypeLevel4_type7: any = 0;

  CoopTypeLevelCount: any;
  viewer: any;
  defect_data = [];
  defect_on = false;
  auth_data: any;

  ViewOAE_1: any;
  ViewOAE_2: any;
  ViewOAE_3: any;
  ViewOAE_1_detail: any;
  ViewOAE_2_detail: any;
  ViewOAE_3_detail: any;
  rubber_sum: any;

  select_title: any;
  show_title: any;
  head_title: any;

  yearData = callable.checkYearNow();
  listYear = callable.listYear();
  listsector = callable.getMasterSector();
  sector_now = callable.getCurrentSector();

  StandardTypeSumClose = true ;
  CoopLevelCountClose = true ;
  ngOnInit(): void {
    this.SpinnerService.show();
    // this.verify_role();
    this.get_auth_verify();
    this.GetPhakList();
    this.GetKhetList();
    this.GetProvinceList();
    this.Info = true;
    this.TypeCoop = true;
    this.year_now = callable.getCurrentYear();
    this.year_now_ = ((new Date()).getFullYear()) + 543;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    registerLocaleData(he);

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }

  }

  async selectNewYearAndSector(year, sector) {
    this.SpinnerService.show();
    if (year) {
      this.year_now = callable.getCurrentYear(year);
    }

    if (sector) {
      this.sector_now = callable.getCurrentSector(sector);
    }

    this.yearData = callable.checkYearNow();

    this.Info = true;
    this.TypeCoop = true;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    this.GetCoopOracleCountNEW();
    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopCommiteeProvinceYearBySearch();
    this.GetCoopSumOfficer();
    this.GetCoopStandardTypeSum();
    this.GetCoopOracleTypes();
    this.GetCoopStatusProvinceYearBySearch();
    this.GetCoopList();
    // this.GetKhetList();
    // this.GetPhakList();
    this.GetCoopTypeLevelCount();
    this.GetDefectProvinceYearSum();
    this.GetViewOAEByGroup();
    this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    //this.get_viewer_province();
    registerLocaleData(he);

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }

    if (this.PhakId != "null") {
      this.searchPhak();
    } else if (this.OrgOrgId != "null") {
      this.searchProvince();
    } else if (this.KhetId != "null") {
      this.searchKhet();
    }


    setTimeout(() => {
      this.SpinnerService.hide();
      // sessionStorage.removeItem(session_year);
    }, 1000);
  }

  verify_role() {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if (user && user['role'] == 'Admin') {
      this.router.navigate(["/user-management"]);
    }
  }

  get_auth_verify() {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    if (this.auth_data != null) {
      this.AuthenService.Get_manage_role(this.auth_data['role']).subscribe(
        responce => {
          if (this.auth_data['role'] == 'Admin') {
            this.defect_on = true;
          } else {
            for (let i = 0; i < responce.length; i++) {
              if (responce[i]['menu'] == 'ข้อบกพร่อง' && responce[i]['status'] == 'y') {
                this.defect_on = true;
              }
            }
          }
        }
      );
    }
  }

  get_date_now_and_after() {
    let Date_today = new Date();
    this.Date_after_day = new Date(Date_today);
    this.Date_after_day.setDate(this.Date_after_day.getDate() - 1);
    this.Month_now = this.Date_after_day.getMonth() + 1;
    this.Date_now = Date_today.getDate()
    this.Date_after_day = this.Date_after_day.getDate()
  }

  get_viewer_phak() {
    let count;
    this.ViewerService.Get_viewerAll('Serach_Phak').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  get_viewer_khet() {
    let count;
    this.ViewerService.Get_viewerAll('Search_Khet').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  get_viewer_province() {
    let count;
    this.ViewerService.Get_viewerAll('Search_Province').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  GetCoopTypeLevelCount() {
    this.CoopServiceService.GetCoopTypeLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopTypeLevelCount = res;
      this.TypeLevelSum1 = 0;
      this.TypeLevelSum2 = 0;
      this.TypeLevelSum3 = 0;
      this.TypeLevelSum4 = 0;

      for (let i = 0; i < res.length; i++) {

        if (res[i].level == "1") {
          this.TypeLevelSum1 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel1_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel1_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel1_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel1_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel1_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel1_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel1_type7 = res[i].count;
          }
        }
        else if (res[i].level == "2") {
          this.TypeLevelSum2 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel2_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel2_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel2_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel2_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel2_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel2_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel2_type7 = res[i].count;
          }
        }
        else if (res[i].level == "3") {
          this.TypeLevelSum3 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel3_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel3_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel3_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel3_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel3_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel3_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel3_type7 = res[i].count;
          }
        }
        else if (res[i].level == "4") {
          this.TypeLevelSum4 += res[i].count;

          if (res[i].type == "1") {
            this.TypeLevel4_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel4_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel4_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel4_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel4_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel4_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel4_type7 = res[i].count;
          }
        }
      }
    })
  }

  select_TypeAgri(data) {
    this.TypeAgri = data;
    if (this.TypeAgri == "TypeAgri") {
      this.TypeAgri = true;
      this.TypeCoop = false;
    }
    this.viewgraph();

  }

  select_TypeCoop(data) {
    this.TypeCoop = data;
    if (this.TypeCoop == "TypeCoop") {
      this.TypeCoop = true;
      this.TypeAgri = false;
    }

    this.viewgraph();
  }

  SearchName() {
    this.SpinnerService.show();
    this.selectPhak = false;
    this.GetPhakList();
    this.GetKhetList();
    this.GetProvinceList();
    if (this.CoopNameTh != "" && this.CoopNameTh != null && this.CoopNameTh != undefined) {
      this.searchName_ = true;
      this.CoopStatusProvinceYearBySearch = null;

      this.CoopServiceService.GetCoopProfileAll(this.CoopNameTh).subscribe(res => {
        this.CoopProfileAll = res;
        for (let i = 0; i < res.length; i++) {
          this.coopId = res[i].coopId;
          this.sumResult = res.length;
          sessionStorage.setItem('coopId', this.coopId);
        }
      })
    } else {
      Swal.fire('Warnning', 'กรุณากรอกข้อมูลที่ต้องการค้นหา', 'warning');

    }
    this.SpinnerService.hide();

  }

  selectCoopProfile(event, check) {
    if (check == 1) {
      this.coopId = this.CoopProfileAll[event].coopId;
    } else if (check == 2) {
      this.coopId = this.pageOfItemslistCoop[event].coopId;
    }

    if (this.coopId != undefined) {
      sessionStorage.setItem('coopId', this.coopId);
      this.router.navigate(["/ProfileCoop"]);
    }
    if (this.coopId == undefined) {
      Swal.fire('Warnning', 'กำลังโหลดข้อมูล กรุณาเลือกอีกครั้ง', 'warning');
    }
  }

  selectProvice_Search(event) {
    this.OrgOrgId = this.pageOfItems[event].orgOrgId;
    // this.OrgOrgId = event;
    this.PhakId = "null";
    this.KhetId = "null";

    this.SpinnerService.show();

    if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
      this.CoopServiceService.GetCoopList(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        this.listCoop = res;
        this.sumResult_ = res.length;


      });
      this.selectProviceSearch = true;

    } else {
      Swal.fire('Warnning', 'กรุณาเลือกข้อมูลที่ต้องการค้นหา', 'warning');
    }
    this.SpinnerService.hide();


  }

  select_Info(data) {
    this.Info = data;
    if (this.Info == "Info") {
      this.Info = true;
      this.List = false;
    }

    this.viewgraph();
  }

  select_List(data) {
    this.SpinnerService.show();
    this.List = data;
    if (this.List == "List") {
      this.Info = false;
      this.List = true;
    }

    // this.viewgraph();
    this.SpinnerService.hide();
  }

  setphak(event) {
    this.PhakId = event;
    this.OrgOrgId = "null";
    this.KhetId = "null";
    const temp = this.PhakList.filter(x => x.phakId == event);
    this.select_title = temp[0]['phakName']

  }

  setkhet(event) {
    this.KhetId_ = event;
    this.KhetId = this.KhetId_;
    this.PhakId = "null";
    this.OrgOrgId = "null";
    const temp = this.checkkhet.filter(x => x.khet_id == event);
    this.select_title = temp[0]['khet_desc']
  }

  setProvince(event) {
    this.OrgOrgId = event;
    this.KhetId = "null";
    this.PhakId = "null";
    const temp = this.ProvinceByKhet.filter(x => x.orgOrgId == event);
    this.select_title = temp[0]['provinceNameSort']
  }

  GetPhakList() {
    this.SpinnerService.show();

    this.CoopServiceService.GetPhakList().subscribe(res => {
      this.PhakList = res;
    });

  }

  GetKhetList() {
    this.CoopServiceService.GetKhetList().subscribe(res => {
      this.checkkhet = res;
    });
  }

  GetProvinceList() {
    this.CoopServiceService.GetProvinceList().subscribe(res => {
      this.ProvinceByKhet = res;
    });
    this.SpinnerService.hide();

  }

  searchPhak() {
    this.SpinnerService.show();
    this.head_title = 'ภาค';
    this.show_title = this.select_title;
    this.listCoop = null;
    this.searchName_ = false;
    this.KhetId = "null";
    this.OrgOrgId = "null";
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetCoopOracleCountNEW();
    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopCommiteeProvinceYearBySearch();
    this.GetCoopSumOfficer();
    this.GetCoopStandardTypeSum();
    this.GetCoopOracleTypes();
    this.GetCoopStatusProvinceYearBySearch();
    this.GetCoopList();
    this.GetKhetList();
    this.GetProvinceList();
    this.GetCoopTypeLevelCount();
    this.GetDefectProvinceYearSum();
    this.GetViewOAEByGroup();
    this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_phak();
  }

  searchKhet() {
    this.SpinnerService.show();
    this.head_title = '';
    this.show_title = this.select_title;
    this.searchName_ = false;
    this.PhakId = "null";
    this.OrgOrgId = "null";
    this.listCoop = null;
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetCoopOracleCountNEW();
    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopCommiteeProvinceYearBySearch();
    this.GetCoopSumOfficer();
    this.GetCoopStandardTypeSum();
    this.GetCoopOracleTypes();
    this.GetCoopStatusProvinceYearBySearch();
    this.GetCoopList();
    this.GetPhakList();
    this.GetProvinceList();
    this.GetCoopTypeLevelCount();
    this.GetDefectProvinceYearSum();
    this.GetViewOAEByGroup();
    this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_khet();
  }

  searchProvince() {
    this.SpinnerService.show();
    this.head_title = 'จังหวัด';
    this.show_title = this.select_title;
    this.listCoop = null;
    this.searchName_ = false;
    this.PhakId = "null";
    this.KhetId = "null";
    this.selectPhak = true;
    this.CoopNameTh = null;
    this.GetCoopOracleCountNEW();
    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopCommiteeProvinceYearBySearch();
    this.GetCoopSumOfficer();
    this.GetCoopStandardTypeSum();
    this.GetCoopOracleTypes();
    this.GetCoopStatusProvinceYearBySearch();
    this.GetCoopList();
    // this.GetKhetList();
    // this.GetPhakList();
    this.GetCoopTypeLevelCount();
    this.GetDefectProvinceYearSum();
    this.GetViewOAEByGroup();
    this.GetViewRubberSumProvinceTotal();
    this.viewgraph();
    this.get_viewer_province();
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  onChangePagelistCoop(pageOfItemslistCoop: Array<any>) {
    // update current page of items
    this.pageOfItemslistCoop = pageOfItemslistCoop;
  }

  GetCoopStatusProvinceYearBySearch() {
    this.SpinnerService.show();
    this.CoopServiceService.GetCoopStatusProvinceYearBySearch(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      this.CoopStatusProvinceYearBySearch = Array(res.length).fill(0).map((x, i) => ({ id: res[i].id, provinceName: res[i].provinceName, active: res[i].active, nonActive: res[i].nonActive, sum: res[i].sum, orgOrgId: res[i].orgOrgId }));
      this.sumResult = res.length;
      this.CoopStatusProvinceYearOne = res;

    });
    this.SpinnerService.hide();
  }

  GetCoopList() {
    this.CoopServiceService.GetCoopList(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      // this.listCoop = res;
      this.listCoop = Array(res.length).fill(0).map((x, i) => ({ id: res[i].id, coopNameTh: res[i].coopNameTh, registryNo2: res[i].registryNo2, stdCode: res[i].stdCode, coopId: res[i].coopId }));
      this.sumResult_ = res.length;
    });
  }

  GetCoopOracleCountNEW() {
    this.CoopServiceService.GetCoopOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      for (let i = 0; i < res.length; i++) {
        this.CoopOracleCount = res[i].coopCount;
        this.CoopOracleCountactive = res[i].active;
        this.CoopOracleCountnonActive = res[i].nonActive;
      }
    })
  }

  GetCoopMemberEachProvinceLastestYear() {
    this.SpinnerService.show();

    // this.CoopServiceService.GetCoopMemberEachProvinceLastestYear(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
    //   this.MemberSum = 0;
    //   this.MemberDataM = 0;
    //   this.MemberDataFm = 0;
    //   for (let i = 0; i < res.length; i++) {
    //     this.MemberSum += res[i].sumData;
    //     this.MemberDataM += res[i].dataFm;
    //     this.MemberDataFm += res[i].dataM;

    //   }
    // });

    this.CoopServiceService.GetCoopSumMember(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.MemberSum = 0;
      this.MemberDataM = 0;
      this.MemberDataFm = 0;
      for (let i = 0; i < res.length; i++) {
        this.MemberSum += res[i].sum;
        this.MemberDataM += res[i].dataFm;
        this.MemberDataFm += res[i].dataM;
      }
    });

  }

  GetCoopCommiteeProvinceYearBySearch() {

    this.CoopServiceService.GetCoopSumCommittee(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CommitteeSum = 0;
      this.CommitteeSumM = 0;
      this.CommitteeSumFm = 0;

      for (let i = 0; i < res.length; i++) {
        this.CommitteeSum += res[i].sum;
        this.CommitteeSumM += res[i].dataM;
        this.CommitteeSumFm += res[i].dataFm;

      }

    });
  }

  GetCoopSumOfficer() {

    this.CoopServiceService.GetCoopSumOfficer(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOfficerYearMember = 0;
      this.CoopOfficerYearMemberM = 0;
      this.CoopOfficerYearMemberFm = 0;
      for (let i = 0; i < res.length; i++) {
        this.CoopOfficerYearMember += res[i].sum;
        this.CoopOfficerYearMemberM += res[i].dataM;
        this.CoopOfficerYearMemberFm += res[i].dataFm;
      }
    })
  }

  GetCoopStandardTypeSum() {
    this.CoopServiceService.GetCoopStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.StandardTypeSum_pass = 0;
      this.StandardTypeSum_notPass = 0;
      for (let i = 0; i < res.length; i++) {

        this.StandardTypeSum_pass += res[i].pass;
        this.StandardTypeSum_notPass += res[i].notPass;

        if (res[i].coopType == "1") {
          this.StandardType_pass_level1 = res[i].pass;
          this.StandardType_notPass_level1 = res[i].notPass;
        }
        else if (res[i].coopType == "2") {
          this.StandardType_pass_level2 = res[i].pass;
          this.StandardType_notPass_level2 = res[i].notPass;
        }
        else if (res[i].coopType == "3") {
          this.StandardType_pass_level3 = res[i].pass;
          this.StandardType_notPass_level3 = res[i].notPass;
        }
        else if (res[i].coopType == "4") {
          this.StandardType_pass_level4 = res[i].pass;
          this.StandardType_notPass_level4 = res[i].notPass;
        }
        else if (res[i].coopType == "5") {
          this.StandardType_pass_level5 = res[i].pass;
          this.StandardType_notPass_level5 = res[i].notPass;
        }
        else if (res[i].coopType == "6") {
          this.StandardType_pass_level6 = res[i].pass;
          this.StandardType_notPass_level6 = res[i].notPass;
        }
        else if (res[i].coopType == "7") {
          this.StandardType_pass_level7 = res[i].pass;
          this.StandardType_notPass_level7 = res[i].notPass;
        }
      }
    })
  }

  GetCoopOracleTypes() {
    this.CoopServiceService.GetCoopOracleTypes(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOracleTypes = res;
      this.Active_coopType1 = 0;
      this.InActive_coopType1 = 0;

      for (let i = 0; i < res.length; i++) {

        this.Active_coopType1 += res[i].active
        this.InActive_coopType1 += res[i].nonActive
        if (res[i].coopType == "1") {
          this.typeName = "สหกรณ์การเกษตร";
        }
        else if (res[i].coopType == "2") {
          this.typeName = "สหกรณ์ประมง";
        }
        else if (res[i].coopType == "3") {
          this.typeName = "สหกรณ์นิคม";
        }
        else if (res[i].coopType == "4") {
          this.typeName = "สหกรณ์ออมทรัพย์";
        }
        else if (res[i].coopType == "5") {
          this.typeName = "สหกรณ์ร้านค้า";
        }
        else if (res[i].coopType == "6") {
          this.typeName = "สหกรณ์บริการ";
        }
        else if (res[i].coopType == "7") {
          this.typeName = "สหกรณ์เครดิตยูเนี่ยน";
        }
      }

    })
  }

  GetDefectProvinceYearSum() {
    this.get_auth_verify();
    this.defect_data = []; //reset data in arr
    let sum_coop_defect = [0, 0, 0, 0, 0, 0];
    let sum_lost_value = [0, 0, 0, 0, 0, 0];
    let defect_name = [];
    let verify_on = false

    if (this.defect_on) {
      this.AuthenService.GetProvinceByUserid(this.auth_data['user_id']).subscribe(
        res => {
          if (this.OrgOrgId != 'null') {// เช็คว่า id ที่ค้นหาตรงกับ สิทธิ์ค้นหาหรือไม่
            for (let i = 0; i < res.length; i++) {
              if (res[i]['orgOrgId'].trim() == this.OrgOrgId) {
                verify_on = true;
                break;
              }
            }
          } else if (this.KhetId != 'null') {
            if (this.auth_data['role'] != 'Provincial_officials') {
              this.CoopServiceService.GetProvinceByKhet(this.KhetId).subscribe(
                response => {
                  for (let i = 0; i < response.length; i++) {
                    for (let j = 0; j < res.length; j++) {
                      if (response[i]['orgOrgId'].trim() == res[j]['orgOrgId'].trim()) {
                        verify_on = true;
                        break;
                      }
                    }
                  }
                }
              );
            }
          }

          if (verify_on || this.auth_data['role'] == 'Admin' || this.auth_data['role'] == 'Executive' || this.auth_data['role'] == 'Central_agency' || this.auth_data['role'] == 'District_inspector') {
            this.CoopServiceService.GetDefectProvinceYearSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
              res => {
                for (let i = 0; i < res.length; i++) {
                  switch (res[i]['defectMainId']) {
                    case "1":
                      sum_coop_defect[0] += res[i]['numCoopDefect'];
                      sum_lost_value[0] += res[i]['lossValue'];
                      defect_name[0] = res[i]['defectMainName'];
                      break;

                    case "2":
                      sum_coop_defect[1] += res[i]['numCoopDefect'];
                      sum_lost_value[1] += res[i]['lossValue'];
                      defect_name[1] = res[i]['defectMainName'];
                      break;

                    case "3":
                      sum_coop_defect[2] += res[i]['numCoopDefect'];
                      sum_lost_value[2] += res[i]['lossValue'];
                      defect_name[2] = res[i]['defectMainName'];
                      break;

                    case "4":
                      sum_coop_defect[3] += res[i]['numCoopDefect'];
                      sum_lost_value[3] += res[i]['lossValue'];
                      defect_name[3] = res[i]['defectMainName'];
                      break;

                    case "5":
                      sum_coop_defect[4] += res[i]['numCoopDefect'];
                      sum_lost_value[4] += res[i]['lossValue'];
                      defect_name[4] = res[i]['defectMainName'];
                      break;

                    case "sum":
                      sum_coop_defect[5] += res[i]['numCoopDefect'];
                      sum_lost_value[5] += res[i]['lossValue'];
                      defect_name[5] = res[i]['defectMainName'];
                      break;
                  }

                }
                for (let j = 0; j < sum_coop_defect.length; j++) {
                  this.defect_data.push(
                    {
                      "defectMainName": defect_name[j],
                      "numCoopDefect": sum_coop_defect[j],
                      "lossValue": sum_lost_value[j].toLocaleString()
                    }
                  );
                }
              }
            );
          } else {
            this.defect_on = false;
          }
        }
      );
    }
  }

  GetViewOAEByGroup() {
    this.CoopServiceService.GetViewOAEByGroup(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
      response => {
        for (let i = 0; i < response.length; i++) {
          response[i]['total_count'] = response[i]['total_count'].toLocaleString();
          response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          if (response[i]['groupCode'] == "1") {
            this.ViewOAE_1 = response[i];
          } else if (response[i]['groupCode'] == "2") {
            this.ViewOAE_2 = response[i];
          } else {
            this.ViewOAE_3 = response[i];
          }
        }
      }
    );
  }

  GetViewOAEDetailByGroup(groupCode) {
    let get = true;
    if (groupCode == 1) {
      if (!this.ViewOAE_1_detail) {
        get = false;
      }
    } else if (groupCode == 2) {
      if (!this.ViewOAE_2_detail) {
        get = false;
      }
    } else {
      if (!this.ViewOAE_3_detail) {
        get = false;
      }
    }

    if (get == false) {
      this.SpinnerService.show();
      this.CoopServiceService.GetViewOAEDetailByGroup(this.OrgOrgId, this.PhakId, this.KhetId, groupCode).subscribe(
        response => {
          for (let i = 0; i < response.length; i++) {
            response[i]['total_count'] = response[i]['total_count'].toLocaleString();
            response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          }

          if (groupCode == 1) {
            this.ViewOAE_1_detail = response;
          } else if (groupCode == 2) {
            this.ViewOAE_2_detail = response;
          } else {
            this.ViewOAE_3_detail = response;
          }
          this.SpinnerService.hide();
        }
      );
    }
  }

  GetViewRubberSumProvinceTotal() {
    const KhetId = this.KhetId.trim()
    this.CoopServiceService.GetViewRubberSumProvinceTotal(this.OrgOrgId, this.PhakId, KhetId).subscribe(
      response => {
        if (response.length != 0) {
          response[0]['total_count'] = response[0]['total_count'].toLocaleString();
          response[0]['total_rai'] = response[0]['total_rai'].toLocaleString();
          this.rubber_sum = response[0];
        }
      }
    );
  }

  Participationinsert() {
    this.CoopServiceService.GetCoopProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_deposit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_credit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_sale) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_good) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }


        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_marketing) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_service) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_other) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation1insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation2insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation3insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation4insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation5insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation6insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation7insert() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_other_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  // viewgraph(): void {
  viewgraph(): void {
    this.SpinnerService.show();

    // มาตรฐานสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        // this.CoopServiceService.GetStandardYear().subscribe(res => {
          if( res.length == 0){
            this.StandardTypeSumClose = true ;
          }else{
              this.StandardTypeSumClose = false ;
          }

      this.StandardTypeSum_pass = 0;
      this.StandardTypeSum_notPass = 0;

       for (let i = 0; i < res.length; i++) {

        this.StandardTypeSum_pass += res[i].pass;
        this.StandardTypeSum_notPass += res[i].notPass;

        if (res[i].coopType == "1") {
          this.StandardType_pass_level1 = res[i].pass;
          this.StandardType_notPass_level1 = res[i].notPass;
        }
        else if (res[i].coopType == "2") {
          this.StandardType_pass_level2 = res[i].pass;
          this.StandardType_notPass_level2 = res[i].notPass;
        }
        else if (res[i].coopType == "3") {
          this.StandardType_pass_level3 = res[i].pass;
          this.StandardType_notPass_level3 = res[i].notPass;
        }
        else if (res[i].coopType == "4") {
          this.StandardType_pass_level4 = res[i].pass;
          this.StandardType_notPass_level4 = res[i].notPass;
        }
        else if (res[i].coopType == "5") {
          this.StandardType_pass_level5 = res[i].pass;
          this.StandardType_notPass_level5 = res[i].notPass;
        }
        else if (res[i].coopType == "6") {
          this.StandardType_pass_level6 = res[i].pass;
          this.StandardType_notPass_level6 = res[i].notPass;
        }
        else if (res[i].coopType == "7") {
          this.StandardType_pass_level7 = res[i].pass;
          this.StandardType_notPass_level7 = res[i].notPass;
        }
      }


     if(this.StandardTypeSum_pass==0 && this.StandardTypeSum_notPass ==0){
         this.StandardTypeSumClose = true ;
      }



        setTimeout(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Standard_insert", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;

        let data = [];
        let sum_standard_pass_
        let sum_standard_not_

        sum_standard_pass_ = this.StandardTypeSum_pass;
        sum_standard_not_ = this.StandardTypeSum_notPass;

        data.push(
          {
            "country": "ผ่านมาตรฐาน",
            "value": sum_standard_pass_,
            "color": am4core.color("#44c70d")
          },
          {
            "country": "ไม่ผ่านมาตรฐาน",
            "value": sum_standard_not_,
            "color": am4core.color("#ca0000")
          }
        )

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "มาตรฐานสหกรณ์";
        title.disabled = false;

        chart.data = data;
        chart.logo.disabled = true;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "มาตรฐานสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        // series.dataFields.radiusValue = "value";
        series.dataFields.category = "country";
        series.slices.template.cornerRadius = 6;
        series.colors.step = 2;
        series.slices.template.propertyFields.fill = "color";
        series.hiddenState.properties.endAngle = -90;

        // เพิ่มตัวเลขในวงกลม
        series.alignLabels = false;
        series.ticks.template.disabled = true;
        series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        series.labels.template.radius = am4core.percent(-90);
        series.labels.template.fill = am4core.color("black");
        series.labels.template.relativeRotation = 90;

        // เปลี่ยนเปอร์เซ็นต์เป็นตัวเลข
        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
      },0);
      })
    })

    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_AN_insert", am4charts.XYChart);
        let data = [];
        let year_now = this.year_now;

        chart.logo.disabled = true;
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.labels.template.disabled = true;
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.fontSize = "11px"

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;
        valueAxis.fontSize = "11px"

        // Create series
        function createSeries(field, name, color) {
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueX = field;
          series.dataFields.categoryY = "year";
          series.stacked = true;
          series.name = name;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationX = 0.5;
          labelBullet.label.text = "{valueX}";
          labelBullet.label.fill = am4core.color("#fff");

        }

        chart.legend = new am4charts.Legend();
        for (let i = 0; i < res.length; i++) {
          // Add data
          data.push(
            {
              "year": year_now,
              "active": res[i].active,
              "nonactive": res[i].nonActive
            }
          )
        }
        chart.data = data;
        chart.logo.disabled = true;
        createSeries("active", "Active", "#4f9f0c");
        createSeries("nonactive", "Non-active", "#aa1107");

      })
    })

    // ระดับชั้นความเข้มแข็ง
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {


        am4core.useTheme(am4themes_dataviz);
        if(res.length == 0){
          this.CoopLevelCountClose = true
        }else{
          this.CoopLevelCountClose = false
        }
        setTimeout(() => {
        var chart = am4core.create("chartdiv_Strong_insert", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;
        let data = [];


        if (parseInt(this.year_now) >= 2565) {
          console.log(1);

          res.pop();
        }

        for (let i = 0; i < res.length; i++) {
            data.push(
              {
                "level": res[i].level,
                "value": res[i].count,
                // "color": am4core.color("#1F9B8C")
              }
            );
        }

        chart.data = data;
        chart.logo.disabled = true;

        chart.radius = am4core.percent(70);
        chart.innerRadius = am4core.percent(40);
        chart.startAngle = 180;
        chart.endAngle = 360;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ระดับขั้นความเข้มแข็ง (หน่วย : สหกรณ์)";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ระดับขั้นความเข้มแข็ง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        var series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        series.dataFields.category = "level";
        series.slices.template.propertyFields.fill = "color";
        series.slices.template.propertyFields.stroke = "color";

        series.slices.template.cornerRadius = 10;
        series.slices.template.innerCornerRadius = 8;
        // series.slices.template.draggable = true;
        series.slices.template.inert = true;
        series.alignLabels = false;

        series.hiddenState.properties.startAngle = 90;
        series.hiddenState.properties.endAngle = 90;

        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
        },0);

      })
    })

    this.CoopServiceService.GetCoopFinance(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ทรัพย์สิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_asset_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_asset) {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // หนี้สิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_debt_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].liabilities) {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ทุน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Capital_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_capital) {
            let tofix = res[i].coop_capital.toFixed(0)
            let str = tofix;

            // 100,000 ล้านล้านบาท
            if (str.length == 17) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 11)
              })
            }
            // 10,000 ล้านล้านบาท
            else if (str.length == 16) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 10)
              })
            }
            // 1,000 ล้านล้านบาท
            else if (str.length == 16) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 10)
              })
            }
            // 100 ล้านล้านบาท
            else if (str.length == 15) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 9)
              })
            }
            // 10 ล้านล้านบาท
            else if (str.length == 14) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 8)
              })
            } else if (str.length == 13) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 7)
              })
            } else if (str.length == 12) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 6)
              })
            } else if (str.length == 11) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 5)
              })
            } else if (str.length == 10) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 4)
              })
            } else if (str.length == 9) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 3)
              })
            } else if (str.length == 8) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 2)
              })
            } else if (str.length == 7) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 1)
              })
            } else if (str.length < 7) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": res[i].coop_capital
              })
            }

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // กำไร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_profit_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_profit) {
            let tofix = res[i].net_profit.toFixed(0)
            let str = tofix;

            // 100,000 ล้านล้านบาท
            if (str.length == 17) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 11)
              })
            }
            // 10,000 ล้านล้านบาท
            else if (str.length == 16) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 10)
              })
            }
            // 1,000 ล้านล้านบาท
            else if (str.length == 16) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 10)
              })
            }
            // 100 ล้านล้านบาท
            else if (str.length == 15) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 9)
              })
            }
            // 10 ล้านล้านบาท
            else if (str.length == 14) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 8)
              })
            } else if (str.length == 13) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 7)
              })
            } else if (str.length == 12) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 6)
              })
            } else if (str.length == 11) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 5)
              })
            } else if (str.length == 10) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 4)
              })
            } else if (str.length == 9) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 3)
              })
            } else if (str.length == 8) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 2)
              })
            } else if (str.length == 7) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": str.slice(0, 1)
              })
            } else if (str.length < 7) {
              net = "หน่วย : ล้านบาท";

              data.push({
                "year": res[i].year,
                "value": res[i].net_profit
              })
            }

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)ของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)ของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ทรัพย์สินของสหกรณ์ ทุกประเภท
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_asset_type_insert", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net_asset_sum_1 = 0
      //   let net_asset_sum_2 = 0
      //   let net_asset_sum_3 = 0
      //   let net_asset_sum_4 = 0
      //   let net_asset_sum_5 = 0

      //   let year_now1
      //   let year_now2
      //   let year_now3
      //   let year_now4
      //   let year_now5
      //   for (let i = 0; i < res.length; i++) {

      //     if (res[i].year == this.year_now) {
      //       net_asset_sum_1 += res[i].net_asset.toFixed(0);
      //       year_now1 = res[i].year;

      //     }
      //     else if (res[i].year - 1) {
      //       net_asset_sum_2 += res[i].net_asset.toFixed(0);
      //       year_now2 = res[i].year;
      //     }
      //     else if (res[i].year - 2) {
      //       net_asset_sum_3 += res[i].net_asset.toFixed(0);
      //       year_now3 = res[i].year;
      //     }
      //     else if (res[i].year - 3) {
      //       net_asset_sum_4 += res[i].net_asset.toFixed(0);
      //       year_now4 = res[i].year;
      //     }
      //     else if (res[i].year - 4) {
      //       net_asset_sum_5 += res[i].net_asset.toFixed(0);
      //       year_now5 = res[i].year;
      //     }
      //   }

      //   // Add data
      //   data.push(
      //     {
      //       "year": year_now1,
      //       "value": net_asset_sum_1
      //     },
      //     {
      //       "year": year_now2,
      //       "value": net_asset_sum_2
      //     },
      //     {
      //       "year": year_now3,
      //       "value": net_asset_sum_3
      //     },
      //     {
      //       "year": year_now4,
      //       "value": net_asset_sum_4
      //     },
      //     {
      //       "year": year_now5,
      //       "value": net_asset_sum_5
      //     }
      //   )

      //   chart.data = data;
      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "ทรัพย์สินของสหกรณ์ ทุกประเภท";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ทุกประเภท";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   // Create axes
      //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //   dateAxis.title.text = "ปีข้อมูล"
      //   dateAxis.fontSize = "11px"

      //   // Create value axis
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "หน่วย : ล้านบาท"
      //   valueAxis.fontSize = "11px"

      //   // Create series
      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.dateX = "year";
      //   lineSeries.name = "Sales";
      //   lineSeries.strokeWidth = 3;

      //   // Add simple bullet
      //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      //   let image = bullet.createChild(am4core.Image);
      //   image.href = "https://www.amcharts.com/lib/images/star.svg";
      //   image.width = 15;
      //   image.height = 15;
      //   image.horizontalCenter = "middle";
      //   image.verticalCenter = "middle";

      //   chart.logo.disabled = true;
      // })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;
      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทรัพย์สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //หนี้สินของสหกรณ์ ทุกประเภท
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_debt_type_insert", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let liabilities_sum_1 = 0
      //   let liabilities_sum_2 = 0
      //   let liabilities_sum_3 = 0
      //   let liabilities_sum_4 = 0
      //   let liabilities_sum_5 = 0

      //   let year_now1
      //   let year_now2
      //   let year_now3
      //   let year_now4
      //   let year_now5
      //   for (let i = 0; i < res.length; i++) {

      //     if (res[0].year) {
      //       liabilities_sum_1 += res[i].liabilities;
      //       year_now1 = res[i].year;

      //     }
      //     else if (res[1].year) {
      //       liabilities_sum_2 += res[i].liabilities;
      //       year_now2 = res[i].year;
      //     }
      //     else if (res[2].year) {
      //       liabilities_sum_3 += res[i].liabilities;
      //       year_now3 = res[i].year;
      //     }
      //     else if (res[3].year) {
      //       liabilities_sum_4 += res[i].liabilities;
      //       year_now4 = res[i].year;
      //     }
      //     else if (res[4].year) {
      //       liabilities_sum_5 += res[i].liabilities;
      //       year_now5 = res[i].year;
      //     }

      //   }

      //   data.push(
      //     {
      //       "year": year_now1,
      //       "value": liabilities_sum_1
      //     },
      //     {
      //       "year": year_now2,
      //       "value": liabilities_sum_2
      //     },
      //     {
      //       "year": year_now3,
      //       "value": liabilities_sum_3
      //     },
      //     {
      //       "year": year_now4,
      //       "value": liabilities_sum_4
      //     },
      //     {
      //       "year": year_now5,
      //       "value": liabilities_sum_5
      //     }
      //   )

      //   chart.data = data;
      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "หนี้สินของสหกรณ์ ทุกประเภท";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ทุกประเภท";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   // Create axes
      //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //   dateAxis.title.text = "ปีข้อมูล"
      //   dateAxis.fontSize = "11px"

      //   // Create value axis
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "หน่วย : ล้านบาท"
      //   valueAxis.fontSize = "11px"

      //   // Create series
      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.dateX = "year";
      //   lineSeries.name = "Sales";
      //   lineSeries.strokeWidth = 3;

      //   // Add simple bullet
      //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      //   let image = bullet.createChild(am4core.Image);
      //   image.href = "https://www.amcharts.com/lib/images/star.svg";
      //   image.width = 15;
      //   image.height = 15;
      //   image.horizontalCenter = "middle";
      //   image.verticalCenter = "middle";

      //   chart.logo.disabled = true;
      // })

      //หนี้สินของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //ทุนของสหกรณ์ ทุกประเภท
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_Capital_type_insert", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let coop_capital_sum_1 = 0
      //   let coop_capital_sum_2 = 0
      //   let coop_capital_sum_3 = 0
      //   let coop_capital_sum_4 = 0
      //   let coop_capital_sum_5 = 0

      //   let year_now1
      //   let year_now2
      //   let year_now3
      //   let year_now4
      //   let year_now5
      //   for (let i = 0; i < res.length; i++) {

      //     if (res[0].year) {
      //       coop_capital_sum_1 += res[i].coop_capital;
      //       year_now1 = res[i].year;

      //     }
      //     else if (res[1].year) {
      //       coop_capital_sum_2 += res[i].coop_capital;
      //       year_now2 = res[i].year;
      //     }
      //     else if (res[2].year) {
      //       coop_capital_sum_3 += res[i].coop_capital;
      //       year_now3 = res[i].year;
      //     }
      //     else if (res[3].year) {
      //       coop_capital_sum_4 += res[i].coop_capital;
      //       year_now4 = res[i].year;
      //     }
      //     else if (res[4].year) {
      //       coop_capital_sum_5 += res[i].coop_capital;
      //       year_now5 = res[i].year;
      //     }
      //   }

      //   // Add data
      //   data.push(
      //     {
      //       "year": year_now1,
      //       "value": coop_capital_sum_1
      //     },
      //     {
      //       "year": year_now2,
      //       "value": coop_capital_sum_2
      //     },
      //     {
      //       "year": year_now3,
      //       "value": coop_capital_sum_3
      //     },
      //     {
      //       "year": year_now4,
      //       "value": coop_capital_sum_4
      //     },
      //     {
      //       "year": year_now5,
      //       "value": coop_capital_sum_5
      //     }
      //   )

      //   chart.data = data;
      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "ทุนของสหกรณ์ ทุกประเภท";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "ทุนของสหกรณ์ ทุกประเภท";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   // Create axes
      //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //   dateAxis.title.text = "ปีข้อมูล"
      //   dateAxis.fontSize = "11px"

      //   // Create value axis
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "หน่วย : ล้านบาท"
      //   valueAxis.fontSize = "11px"

      //   // Create series
      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.dateX = "year";
      //   lineSeries.name = "Sales";
      //   lineSeries.strokeWidth = 3;

      //   // Add simple bullet
      //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      //   let image = bullet.createChild(am4core.Image);
      //   image.href = "https://www.amcharts.com/lib/images/star.svg";
      //   image.width = 15;
      //   image.height = 15;
      //   image.horizontalCenter = "middle";
      //   image.verticalCenter = "middle";

      //   chart.logo.disabled = true;
      // })

      //ทุนของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      //กำไรของสหกรณ์ ทุกประเภท
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_profit_type_insert", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net_profit_sum_1 = 0
      //   let net_profit_sum_2 = 0
      //   let net_profit_sum_3 = 0
      //   let net_profit_sum_4 = 0
      //   let net_profit_sum_5 = 0

      //   let year_now1
      //   let year_now2
      //   let year_now3
      //   let year_now4
      //   let year_now5
      //   for (let i = 0; i < res.length; i++) {

      //     if (res[0].year) {
      //       net_profit_sum_1 += res[i].net_profit;
      //       year_now1 = res[i].year;

      //     }
      //     else if (res[1].year) {
      //       net_profit_sum_2 += res[i].net_profit;
      //       year_now2 = res[i].year;
      //     }
      //     else if (res[2].year) {
      //       net_profit_sum_3 += res[i].net_profit;
      //       year_now3 = res[i].year;
      //     }
      //     else if (res[3].year) {
      //       net_profit_sum_4 += res[i].net_profit;
      //       year_now4 = res[i].year;
      //     }
      //     else if (res[4].year) {
      //       net_profit_sum_5 += res[i].net_profit;
      //       year_now5 = res[i].year;
      //     }
      //   }

      //   // Add data
      //   data.push(
      //     {
      //       "year": year_now1,
      //       "value": net_profit_sum_1
      //     },
      //     {
      //       "year": year_now2,
      //       "value": net_profit_sum_2
      //     },
      //     {
      //       "year": year_now3,
      //       "value": net_profit_sum_3
      //     },
      //     {
      //       "year": year_now4,
      //       "value": net_profit_sum_4
      //     },
      //     {
      //       "year": year_now5,
      //       "value": net_profit_sum_5
      //     }
      //   )

      //   chart.data = data;
      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "กำไรของสหกรณ์ ทุกประเภท";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "กำไรของสหกรณ์ ทุกประเภท";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   // Create axes
      //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //   dateAxis.title.text = "ปีข้อมูล"
      //   dateAxis.fontSize = "11px"

      //   // Create value axis
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "หน่วย : ล้านบาท"
      //   valueAxis.fontSize = "11px"

      //   // Create series
      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.dateX = "year";
      //   lineSeries.name = "Sales";
      //   lineSeries.strokeWidth = 3;

      //   // Add simple bullet
      //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      //   let image = bullet.createChild(am4core.Image);
      //   image.href = "https://www.amcharts.com/lib/images/star.svg";
      //   image.width = 15;
      //   image.height = 15;
      //   image.horizontalCenter = "middle";
      //   image.verticalCenter = "middle";

      //   chart.logo.disabled = true;
      // })

      //กำไรของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ทรัพย์สิน";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })

    this.CoopServiceService.GetCoopBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // เก่า model
      // ปริมารธุรกิจ รับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].deposit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ ให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_lend_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].credit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_products_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sale_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ รวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_produce_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].collect_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ แปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_Processing_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].transfrom_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ บรืการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_service_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";

        for (let i = 0; i < res.length; i++) {
          if (res[i].service_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum1 = this.valSum1
            data.push({
              "year": res[i].year,
              "value": valSum1
            })
          }
          else if (res[1].year) {
            this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum2 = this.valSum2
            data.push({
              "year": res[i].year,
              "value": valSum2
            })
          }
          else if (res[2].year) {
            this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum3 = this.valSum3

            data.push({
              "year": res[i].year,
              "value": valSum3
            })
          }
          else if (res[3].year) {
            this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum4 = this.valSum4

            data.push({
              "year": res[i].year,
              "value": valSum4
            })
          }
          else if (res[4].year) {
            this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum5 = this.valSum5
            data.push({
              "year": res[i].year,
              "value": valSum5
            })
          }

        }

        chart.data = data;
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //ปริมาณธุรกิจ (รับฝากเงิน) แบ่งตามประเภทสหกรณ์
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_business_deposit_type_insert", am4charts.XYChart);

      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net = "หน่วย : ล้านบาท";
      //   let sum_1 = 0
      //   let sum_2 = 0
      //   let sum_3 = 0
      //   let sum_4 = 0
      //   let sum_5 = 0

      //   for (let i = 0; i < res.length; i++) {

      //     if (res[0].year) {
      //       sum_1 += res[i].deposit_val;


      //       data.push({
      //         "year": res[i].year,
      //         "value": sum_1
      //       })

      //     }
      //     else if (res[1].year) {
      //       sum_2 += res[i].deposit_val;
      //       data.push({
      //         "year": res[i].year,
      //         "value": sum_2
      //       })
      //     }
      //     else if (res[2].year) {
      //       sum_3 += res[i].deposit_val;
      //       data.push({
      //         "year": res[i].year,
      //         "value": sum_3
      //       })
      //     }
      //     else if (res[3].year) {
      //       sum_4 += res[i].deposit_val;
      //       data.push({
      //         "year": res[i].year,
      //         "value": sum_4
      //       })
      //     }
      //     else if (res[4].year) {
      //       sum_5 += res[i].deposit_val;
      //       data.push({
      //         "year": res[i].year,
      //         "value": sum_5
      //       })
      //     }
      //   }

      //   chart.data = data;

      //   // Create axes
      //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //   dateAxis.title.text = "ปีชุดข้อมูล"
      //   dateAxis.fontSize = "11px"

      //   // Create value axis
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = net
      //   valueAxis.fontSize = "11px"

      //   // Create series
      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.dateX = "year";
      //   lineSeries.name = "Sales";
      //   lineSeries.strokeWidth = 3;

      //   // Add simple bullet
      //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      //   let image = bullet.createChild(am4core.Image);
      //   image.href = "https://www.amcharts.com/lib/images/star.svg";
      //   image.width = 15;
      //   image.height = 15;
      //   image.horizontalCenter = "middle";
      //   image.verticalCenter = "middle";

      //   chart.logo.disabled = true;
      // })

      // ปริมาณธุรกิจ เกษตร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_business_type1_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')


      })

      // ปริมาณธุรกิจ นิคม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้าน้คา ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_deposit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_credit_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_sale_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_collect_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_transfrom_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_service_val_insert", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท";
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type1_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '1') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type2_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '2') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }
        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type3_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '3') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type4_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '4') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type5_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '5') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type6_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '6') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ เครดิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type7_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท";
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '7') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    });

    // การมีส่วนร่วมของสมาชิกสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop_sum_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].year != '2558') {
            data.push(
              {
                "year": res[i].year,
                "value": res[i].sum_member
              }
            )
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })
    })

    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ การเกษตร
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทการเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทการเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_fishing_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_Settlement_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทนิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทนิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_saving_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_shop_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ เครดิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit_insert", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })
    })

    this.SpinnerService.hide();


  }

  ngOnDestroy() {
    // Clean up chart when the component is removed

    this.zone.runOutsideAngular(() => {

      am4core.disposeAllCharts();

    });
  }

}
